export default __webpack_public_path__ + "static/media/intro.a2e61d37.svg";